import React from 'react'
import { useStatusesForProject } from '../../hooks/graphql'

interface Props {
  projectName: string
  selectedStatusId: number | null
  statusChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

function ProjectStatuses({ projectName, selectedStatusId, statusChangeHandler }: Props) {
  const statusesForProject = useStatusesForProject(selectedStatusId)

  return (
    <>
      <select
        onChange={statusChangeHandler}
        value={selectedStatusId ?? ''}
        className="w-full form-select font-body h-12 text-gray-900 bg-gray-100 block rounded-md py-2 text-base leading-6 border outline-none focus:shadow-focus focus:border-4 border-solid border-gray-400 focus:border-blue-400"
      >
        {statusesForProject.map((status) => (
          <option key={status.id} value={status.id}>
            {status.label}
          </option>
        ))}
      </select>
    </>
  )
}

export default ProjectStatuses
